class mainImgTabSwiper extends HTMLElement {
  constructor() {
    super();
    this.index = 0;
    this.sectionId = this.dataset.sectionId;
    this.thumbSwiper = null;
  }
  connectedCallback(){
    this.headerHeight = document.querySelector('sticky-header') && document.querySelector('sticky-header').offsetHeight;
    this.announcementBarHeight = document.querySelector('announcement-bar') && document.querySelector('announcement-bar').offsetHeight;
    // window.onload = ()=>{
    //   this.querySelectorAll('.text-wrapper.swiper-slide[data-scroll]').forEach(item=>{
    //     item.onclick = ()=>{
          
    //     }
    //   })
    // }
    setTimeout(()=>{
      this.mainImgProductSwiper();
      this.fixedProductSwiper();
      this.init();
    },1000)
  }
  init(){
    const io = new IntersectionObserver((entries) => {
          entries.forEach(item => {
              if(item.isIntersecting) {
                   item.target.classList.add('ani-up')
                   item.target.style.display = 'block'
                   item.target.querySelector('img').style.display = 'block';
                   if(item.target.querySelector('.img-two'))item.target.querySelector('.img-two').style.display = 'block';
                   io.unobserve(item.target);
              }
          })
      },{
        rootMargin: '-100px 0px 100px 0px'
      })
      const h = this.querySelectorAll('.slide-product-wrapper');
      h.forEach(item => {
          io.observe(item)
      })
      const observes = new IntersectionObserver((entries) => {
          entries.forEach(item => {
              if(item.isIntersecting) {
                // item.target.src = item.target.dataset.src
                setTimeout(()=>{
                  let {sources} = this.strToJson(item.target.dataset.json);
                  let temp = '';
                  for(let i = 0;i<sources.length;i++){
                    if(sources[i].format == 'mp4'){
                      temp += `
                          <source src="${sources[i].url}" type="${sources[i].mime_type}">
                      `
                    }
                  }
                  item.target.innerHTML = temp;
                  observes.unobserve(item.target);
                },2500)
              }
          })
      },{
        rootMargin: '-100px 0px 100px 0px'
      })
      const v = this.querySelectorAll('.card-product-wrapper video');
      v.forEach(item => {
          observes.observe(item)
      })
  }
  mainTabSwiper(){
    let that = this;
    return new Swiper(`.main-tab-wrapper-${this.sectionId}`,{
      observer: true, 
      observerParents: true,
      slidesPerView: 'auto',
      resistanceRatio:0,
      allowTouchMove:false,
      spaceBetween : 0,
      breakpoints: {
        750:{
          spaceBetween : 24,
        },
        1024:{
          spaceBetween : 40,
        },
        1440:{
          spaceBetween : 80,
        }
      },
      on:{
        init(){
          let tabWrapper = this.$el[0].querySelectorAll('.swiper-slide')
          tabWrapper.forEach((item)=>{
            if(item.getAttribute('data-scroll')){
              item.classList.add('swiper-no-swiping');
              item.onclick = ()=>{
                let height = that.querySelector(`.fixed-product-wrapper[data-title="${item.getAttribute('data-scroll')}"]`).getBoundingClientRect().bottom - that.announcementBarHeight - that.headerHeight;
                window.scrollTo({
                  top: height,
                  behavior: 'smooth'
                }); 
              }
            }
          })
        }
      }
    })
  }
  mainImgProductSwiper(){
    if(!this.querySelector('.main-img-tab-swiper-warpper')) return;
    let thumbs = this.querySelector('.main-tab-wrapper') ? {
      swiper:this.mainTabSwiper(),
      watchSlidesVisibility: true,
      autoScrollOffset: 1
    } : false;
    new Swiper(`.main-img-tab-swiper-warpper-${this.sectionId}`,{
      observer: true, 
      observerParents: true,
      spaceBetween : 12,
      thumbs,
      resistanceRatio:0,
      breakpoints: {
        750:{

        },
        1440:{
          slidesPerView: 1,
          spaceBetween : 18,
        }
      },
      on:{
        // init(){
        //   setTimeout(()=>{
        //     this.$el[0].style.height = `${this.slides[this.realIndex].offsetHeight}px`;
        //   },200)
        // },
        // slideChangeTransitionEnd(){
        //   setTimeout(()=>{
        //     this.$el[0].style.height = `${this.slides[this.realIndex].offsetHeight}px`;
        //   },1000)
        // }
      }
    })
  }
  fixedProductSwiper(){
    if(!this.querySelector('.fixed-product-wrapper .swiper-wrapper')) return;
    new Swiper(`.fixed-product-wrapper-${this.sectionId}`,{
      observer: true, 
      observerParents: true,
      spaceBetween:12,
      slidesPerView: "auto",
      resistanceRatio:0,
      breakpoints: {
        750:{
          spaceBetween : 12,
        },
        1440:{
          spaceBetween : 10,
        }
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable:true
      },
    })
  }
}
customElements.define('main-img-tab-swiper', mainImgTabSwiper);
